export const TERMS_OF_USE_VERSION = '1.1';
